export default __webpack_public_path__ + "static/media/dam-scratch-starter-puzzle-ocean-1.6a37cdce.jpg";